import Navigation from "../components/Navigation"
import ReactDOM from 'react-dom';
import { SearchProvider } from '^/SearchContext';

ReactDOM.render(
  <SearchProvider>
    <Navigation />
  </SearchProvider>
  , document.getElementById('nav-react'));
